import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PipelineStrip } from "@/components/monitor/PipelineStrip";
import { ControlsBar } from "@/components/monitor/ControlsBar";
import { KpiRow, LiveStream } from "@/components/monitor/KpiStream";
import { Heatmap, LatencyPanel } from "@/components/monitor/Charts";
import { AcceptancePanel, CasesPanel } from "@/components/monitor/OpsPanels";
import { EvaluatePanel } from "@/components/monitor/EvaluatePanel";
import { PolicyPanel } from "@/components/monitor/PolicyPanel";
import { EvalDrawer } from "@/components/monitor/EvalDrawer";
import { PilotExport, ProductivityPanel } from "@/components/monitor/Reports";

export default function Monitor() {
  const [d, setD] = useState(null);
  const [source, setSource] = useState("all");
  const [open, setOpen] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(() => api.get("/monitor/dashboard", { params: { source, minutes: 60 } }).then((r) => { setD(r.data); setErr(null); }).catch((e) => setErr(e.response?.data?.detail || "Dashboard unavailable")), [source]);
  useEffect(() => { load(); const t = setInterval(load, 3000); return () => clearInterval(t); }, [load]);
  return (
    <div className="flex-1 min-w-0 overflow-y-auto thin-scroll grid-bg" data-testid="monitor-page">
      <div className="px-5 sm:px-8 py-8 space-y-4 max-w-[1600px]">
        <div className="rise">
          <div className="chip border-sky-200 bg-sky-50 text-sky-700 mb-3"><span className="w-1.5 h-1.5 rounded-full bg-sky-500 animate-pulse" />Real-time monitoring</div>
          <h1 className="font-display text-4xl lg:text-5xl font-extrabold tracking-tight hero-title pb-1">Every payment, explained in milliseconds</h1>
          <p className="text-sm text-slate-600 mt-2 max-w-3xl">One evaluation API runs all detectors on every rail, applies the bank's policy order and returns an explainable recommendation with reason codes, evidence and versions. Cases, dual-control approvals and bank acknowledgements are tracked end to end in a tamper-evident audit trail.</p>
        </div>
        {err && <div className="text-xs text-red-600" data-testid="monitor-error">{err}</div>}
        <PipelineStrip d={d} />
        {d && <>
          <ControlsBar d={d} source={source} setSource={setSource} reload={load} />
          <KpiRow d={d} />
          <div className="grid grid-cols-1 xl:grid-cols-[1.15fr_1fr] gap-4 [&>*]:min-w-0">
            <LiveStream rows={d.stream} onOpen={setOpen} />
            <div className="space-y-4"><LatencyPanel d={d} /><Heatmap d={d} /></div>
          </div>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 [&>*]:min-w-0"><CasesPanel d={d} onOpen={setOpen} /><AcceptancePanel d={d} reload={load} onOpen={setOpen} /></div>
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 [&>*]:min-w-0"><EvaluatePanel onOpen={setOpen} reload={load} /><PolicyPanel /></div>
          <div className="grid grid-cols-1 xl:grid-cols-[1.4fr_1fr] gap-4 [&>*]:min-w-0"><ProductivityPanel /><PilotExport /></div>
          <div className="text-[10px] text-slate-500" data-testid="monitor-footnote">Simulated feed transactions and their KYC profiles are SAMPLE data, labelled "sim". Sanctions screening uses the live OFAC SDN list. Scores, weights and thresholds are illustrative and not empirically validated; this is not legal advice.</div>
        </>}
      </div>
      <EvalDrawer eid={open} onClose={() => setOpen(null)} onChanged={load} />
    </div>
  );
}
